import { Grid, styled } from '@mui/material';
import { ITeam } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

export interface IAssignState {
  currentUserTeams?: ITeam[];
  currentUserTeamsArray?: INameAndId[];
  currentUserTeamsID?: string[];
}
export interface INameAndId {
  name: string;
  id: string;
}

export const StyledFooter = styled(Grid)(() => ({
  position: 'fixed',
  bottom: '10px',
  textAlign: 'center',
  right: '5px',
  justifyContent: 'flex-end',
  width: '29vw',
  backgroundColor: WsColors.White,
}));
